export const DAY_MS = 24 * 60 * 60 * 1000;
export const MIDDAY_OFFSET_MS = 12 * 60 * 60 * 1000;

export const getStartOfDayMs = (ms: number): number => {
  const date = new Date(ms);
  date.setHours(0, 0, 0, 0);
  return date.getTime();
};
